<!--
  ~ Copyright (c) 2023 D2ArmorPicker by Mijago.
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published
  ~ by the Free Software Foundation, either version 3 of the License, or
  ~ (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <http://www.gnu.org/licenses/>.
  -->

<div id="account-config-container">
  <a class="returnbutton hide-gt-sm" color="primary" mat-raised-button routerLink="/">
    Return to D2ArmorPicker
  </a>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title> Account Configuration </mat-card-title>
      <mat-card-subtitle>
        The configuration on this page will not be reset when you reset your build settings.
      </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      This will come in a future update. Right now, I just wanted to push the "Debugging" section
      out.
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title> Debugging </mat-card-title>
      <mat-card-subtitle> Some options for debugging purposes. </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      If the team asks you to send some specific data, you can find it here:<br />
      <a
        (click)="downloadArmorInformation()"
        class="btn-download"
        color="primary"
        mat-raised-button>
        Download armor information (d2ap_armor.json)
      </a>
      <a
        (click)="downloadManifestInformation()"
        class="btn-download"
        color="primary"
        mat-raised-button>
        Download manifest information (d2ap_manifest.json)
      </a>
      <br />
      <br />

      If you experience issues with the local database - for example, exotics not being found, try
      this:<br />
      <a (click)="resetDatabase()" class="btn-download" color="warn" mat-raised-button>
        Delete Database </a
      ><br />
      If you really want to reset EVERYTHING, use this: <br />
      <a (click)="resetEverything()" class="btn-download" color="warn" mat-raised-button>
        Reset the whole application
      </a>
    </mat-card-content>
  </mat-card>

  <a class="returnbutton hide-gt-sm" color="primary" mat-raised-button routerLink="/">
    Return to D2ArmorPicker
  </a>
</div>
